import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { AppSettings } from '../settings/app.settings';
import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { SEOService } from '../shared/seo-service';


@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.scss']
})
export class HealthCheckComponent implements OnInit{
  constructor(private meta:Meta, private hlang:HrefLang){}

  ngOnInit(){
    let tag:MetaDefinition = {
        name:"robots",
        content:"noindex,nofollow"
      };
    this.meta.addTags([tag]);

    let langs = [
        {lang:'es',text:'health-check'},
        {lang:'en',text:'health-check'},
        {lang:'fr',text:'health-check'},
        {lang:'it',text:'health-check'},
        {lang:'de',text:'health-check'}];
      langs.forEach(lang => {
        let hreflang_:HrefLangDefinition = {
          rel: "alternate",
          href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
          hreflang: `${lang.lang}`
        }
        this.hlang.addTags([hreflang_]);
      });
  }

}